import React from "react";
import { Outlet } from "react-router-dom";

import { SpacesSidebar } from "@/features/spaces/SpacesSidebar";

//
// Shared sub-layout that pins the quick-switch Spaces rail to the left of the
// page content. It is mounted only around the Home and single-Space routes (see
// routes/index.tsx), so the rail "always stays" while moving between those two
// while every other company page keeps its full-width layout.
//
// It renders *inside* CompanyLayout's scroll container, so it never touches the
// top navigation/header — the rail simply sticks to the top of the scrolling
// canvas.
//
export default function SpacesRailLayout() {
  return (
    <div className="flex items-stretch min-h-full">
      <aside className="hidden lg:block shrink-0 w-72 border-r border-stroke-base bg-surface-base">
        <div className="sticky top-0 max-h-screen overflow-y-auto">
          <SpacesSidebar />
        </div>
      </aside>

      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
